import Vue from 'vue';

Vue.component('car-comparison-component', {
    props: {
        allCarVariants: {
            type: Array,
        },
        defaultVariants: {
            type: Array,
        },
    },

    data() {
        return {
            compareCars: [],
            showAllSpecs: false,
            activeModelSelection: null,
            allCarVariantsWithVersionIconName: null,
            isTransitioning: false,
        };
    },

    mounted() {
        this.allCarVariantsWithVersionIconName = this.allCarVariants.map(
            (car) => {
                return this.getCarWithVersionIcon(
                    car,
                    car.field_comparisonLabelText,
                );
            },
        );

        if (this.defaultVariants[0]) {
            this.compareCars.push(
                this.getVariantWithParent(
                    this.defaultVariants[0].parentId,
                    parseInt(this.defaultVariants[0].id),
                ),
            );
        }

        if (this.defaultVariants[1]) {
            this.compareCars.push(
                this.getVariantWithParent(
                    this.defaultVariants[1].parentId,
                    parseInt(this.defaultVariants[1].id),
                ),
            );
        }
    },

    watch: {
        // This prevents scroll reset immediately after the dropdown closes to fix a "glitch" where scroll resets
        // before vue transition finishes
        activeModelSelection(newScrollValue, oldScrollValue) {
            if (oldScrollValue === null && newScrollValue !== null) return;

            setTimeout(() => {
                const scrollArea = this.$refs['scrollArea' + oldScrollValue];

                if (scrollArea && scrollArea[0]) {
                    scrollArea[0].style.overflowY = 'auto';
                    scrollArea[0].style.pointerEvents = 'auto';
                    scrollArea[0].scrollTop = 0;
                }

                this.isTransitioning = false;
            }, 350);
        },
    },

    methods: {
        getVariantWithParent(parentId, variantId) {
            for (let i = 0; i < this.allCarVariants.length; i++) {
                if (this.allCarVariants[i].id == parentId) {
                    for (
                        let j = 0;
                        j < this.allCarVariants[i].variants.length;
                        j++
                    ) {
                        if (
                            parseInt(this.allCarVariants[i].variants[j].id) ==
                            variantId
                        ) {
                            const comparableCar =
                                this.allCarVariants[i].variants[j];

                            comparableCar.modelTitle =
                                this.allCarVariants[i].title;
                            comparableCar.removeSpace =
                                this.allCarVariants[
                                    i
                                ].field_compareModelRemoveTitleSpace;
                            comparableCar.compareLabelText =
                                this.allCarVariants[
                                    i
                                ].field_comparisonLabelText;
                            comparableCar.compareLabelColor =
                                this.allCarVariants[
                                    i
                                ].field_comparisonLabelColor;

                            const comparableCarWithVersionIcon =
                                this.getCarWithVersionIcon(
                                    comparableCar,
                                    comparableCar.compareLabelText,
                                );
                            return comparableCarWithVersionIcon;
                        }
                    }
                }
            }
            return null;
        },

        getProduct(productId) {
            for (let i = 0; i < this.allCarVariants.length; i++) {
                if (this.allCarVariants[i].id === productId) {
                    return this.allCarVariants[i];
                }
            }
            return null;
        },

        toggleSpecs() {
            this.showAllSpecs = !this.showAllSpecs;
        },

        persistScrollDistance(index) {
            const scrollArea = this.$refs['scrollArea' + index];

            if (!scrollArea[0]) return;
            const currentScrollTop = scrollArea[0].scrollTop;

            this.isTransitioning = true;

            scrollArea[0].style.overflowY = 'hidden';
            scrollArea[0].style.pointerEvents = 'none';
            scrollArea[0].scrollTop = currentScrollTop;
        },

        toggleModelSelection(compareCarIndex) {
            const activeModelSelectionExists =
                this.activeModelSelection !== null;
            const isActiveModelSelectionEqualToCompareCarIndex =
                activeModelSelectionExists &&
                compareCarIndex === this.activeModelSelection;

            if (isActiveModelSelectionEqualToCompareCarIndex) {
                this.persistScrollDistance(compareCarIndex);
                this.activeModelSelection = null;
                return;
            }

            this.activeModelSelection = compareCarIndex;

            this.$nextTick(() => {
                this.initScrollbar(compareCarIndex);
            });
        },

        removeCar(compareCarIndex) {
            this.compareCars.splice(compareCarIndex, 1);
        },

        updateCar(compareCarIndex, variantId, parentId) {
            const newCar = this.getVariantWithParent(
                parentId,
                parseInt(variantId),
            );
            const cars = this.compareCars;

            if (!newCar) return;
            this.persistScrollDistance(compareCarIndex);

            cars[compareCarIndex] = newCar;
            this.compareCars = [...cars];
            this.activeModelSelection = null;
        },

        addCar() {
            if (this.defaultVariants[2]) {
                this.compareCars.push(
                    this.getVariantWithParent(
                        this.defaultVariants[2].parentId,
                        parseInt(this.defaultVariants[2].id),
                    ),
                );
            } else {
                this.compareCars.push(
                    this.getVariantWithParent(
                        this.defaultVariants[0].parentId,
                        parseInt(this.defaultVariants[0].id),
                    ),
                );
            }
        },

        getCarWithVersionIcon(model, versionLabelText) {
            let versionIconName = '';
            switch (versionLabelText) {
                case 'Electric':
                case 'Électrique':
                    versionIconName = 'electric-icon';
                    break;
                case 'Plug-In Hybrid':
                    versionIconName = 'hybrid-icon';
                    break;
                case 'Hybrid':
                    versionIconName = 'hev-icon';
                    break;
                case 'Petrol':
                    versionIconName = 'petrol-icon';
                    break;
            }

            model.versionIconName = versionIconName;
            return model;
        },

        getDropdownActiveStateClass(index, variant) {
            if (this.compareCars[index].id !== variant.id) return;
            return 'comparison__model-selection-model-variants-variant--active';
        },

        handleComparisonScroll(carIndex, e) {
            const scrollArea = e.target;
            const scrollBar = this.$refs['scrollBar' + carIndex];
            const scrollTrack = this.$refs['scrollTrack' + carIndex];

            if (!scrollArea || !scrollBar || !scrollTrack) return;

            const scrollBarElement = scrollBar[0];
            const scrollTrackElement = scrollTrack[0];

            if (!scrollBarElement || !scrollTrackElement) return;

            const scrollTop = scrollArea.scrollTop;
            const scrollHeight = scrollArea.scrollHeight;
            const clientHeight = scrollArea.clientHeight;
            const maxScroll = scrollHeight - clientHeight;

            const scrollPercentage = scrollTop / maxScroll;
            const trackHeight = scrollTrackElement.clientHeight;
            const barHeight = scrollBarElement.clientHeight;
            const maxTop = trackHeight - barHeight;

            const thumbTop = scrollPercentage * maxTop;
            scrollBarElement.style.top = thumbTop + 'px';
        },

        initScrollbar(carIndex) {
            const scrollArea = this.$refs['scrollArea' + carIndex];
            const scrollTrack = this.$refs['scrollTrack' + carIndex];
            const scrollBar = this.$refs['scrollBar' + carIndex];

            if (!scrollArea || !scrollTrack || !scrollBar) return;

            const scrollAreaElement = scrollArea[0];
            const scrollTrackElement = scrollTrack[0];
            const scrollBarElement = scrollBar[0];

            if (!scrollAreaElement || !scrollTrackElement || !scrollBarElement)
                return;

            if (!this.isTransitioning) {
                scrollAreaElement.scrollTop = 0;
            }

            const scrollRatio =
                scrollAreaElement.clientHeight / scrollAreaElement.scrollHeight;
            const thumbHeight = scrollRatio * scrollTrackElement.clientHeight;

            scrollBarElement.style.height = thumbHeight + 'px';
            scrollBarElement.style.top = '0px';
        },
    },
});
